import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import CustomBackend from './CustomBackend';

export const supportedLngs: { [key: string]: { name: string; locale: string } } = {
  da: {
    name: 'Dansk',
    locale: 'da-DK',
  },
  en: {
    name: 'English',
    locale: 'en-US',
  },
  es: {
    name: 'Español',
    locale: 'es-ES',
  },
  fr: {
    name: 'Français',
    locale: 'fr-FR',
  },
  ja: {
    name: '日本語',
    locale: 'ja-JP',
  },
  nl: {
    name: 'Nederlands',
    locale: 'nl-NL',
  },
  ptBR: {
    name: 'Português Brasileiro',
    locale: 'pt-BR',
  },
  tr: {
    name: 'Türkçe',
    locale: 'tr-TR',
  },
  it: {
    name: 'Italiano',
    locale: 'it-IT',
  },
};

i18next
  .use(CustomBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: Object.keys(supportedLngs),
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      customerId: '',
    },
  });

// Add refresh translations function
export const refreshTranslations = async () => {
  const backend = i18next.services.backendConnector.backend as typeof CustomBackend;
  if (backend.clearCache) {
    backend.clearCache();
  }
  await i18next.reloadResources();
};

export default i18next;
